/**
 * Le plan de navigation, en données.
 *
 * Repris de `21-workflows-et-diagrammes.md`. Chaque entrée porte les profils qui la voient, ce qui
 * masque le module de paramétrage pour un non-administrateur.
 *
 * **Le masquage est un confort, jamais une sécurité** (`07-frontend-react.md`) : le serveur refuse de
 * toute façon. Mais un menu qui proposerait un écran voué au `403` serait un défaut d'ergonomie, et
 * `routePrincipale` sert à le prouver — un test compare ces profils à `x-profils-autorises` du
 * contrat, et échoue si le menu promet plus que l'API n'accorde.
 */
import type { Profil } from "../shared/api/types";

export type EntreeDeMenu = {
  chemin: string;
  libelle: string;
  profils: readonly Profil[];
  /** Route d'API dont dépend l'écran, au format du contrat OpenAPI. */
  routePrincipale: string;
};

const TOUS: readonly Profil[] = [
  "admin-totalenergies",
  "operationnel-totalenergies",
  "air-tahiti",
  "support",
];
const SANS_SUPPORT: readonly Profil[] = [
  "admin-totalenergies",
  "operationnel-totalenergies",
  "air-tahiti",
];
const SANS_AIR_TAHITI: readonly Profil[] = [
  "admin-totalenergies",
  "operationnel-totalenergies",
  "support",
];
const ADMIN: readonly Profil[] = ["admin-totalenergies"];

export const MENU: readonly EntreeDeMenu[] = [
  {
    chemin: "/",
    libelle: "Tableau de bord",
    profils: TOUS,
    routePrincipale: "GET /v1/kpi/tableau-de-bord",
  },
  { chemin: "/carte", libelle: "Carte", profils: TOUS, routePrincipale: "GET /v1/grv" },
  { chemin: "/grv", libelle: "Parc GRV", profils: TOUS, routePrincipale: "GET /v1/grv" },
  {
    chemin: "/trackers",
    libelle: "Parc Trackers",
    profils: SANS_AIR_TAHITI,
    routePrincipale: "GET /v1/trackers",
  },
  {
    chemin: "/mouvements",
    libelle: "Mouvements",
    profils: TOUS,
    routePrincipale: "GET /v1/mouvements",
  },
  {
    chemin: "/maintenance",
    libelle: "Maintenance",
    profils: SANS_AIR_TAHITI,
    routePrincipale: "GET /v1/maintenance",
  },
  {
    chemin: "/documents",
    libelle: "Documents",
    profils: SANS_SUPPORT,
    routePrincipale: "GET /v1/documents",
  },
  { chemin: "/alertes", libelle: "Alertes", profils: TOUS, routePrincipale: "GET /v1/alertes" },
  {
    chemin: "/rapports",
    libelle: "Rapports",
    profils: SANS_SUPPORT,
    routePrincipale: "GET /v1/rapports",
  },
  {
    chemin: "/parametrage",
    libelle: "Paramétrage",
    profils: ADMIN,
    routePrincipale: "GET /v1/admin/seuils",
  },
];

export function menuPour(profil: Profil): readonly EntreeDeMenu[] {
  return MENU.filter((entree) => entree.profils.includes(profil));
}
